<!--
 * @Descripttion: 
 * @version: 1.0
 * @Author: Erik Zhang
 * @Date: 2021-02-14 23:36:16
 * @LastEditors: Erik Zhang
 * @LastEditTime: 2021-04-18 11:48:28
-->
<template>
  <edu-layout type="table">
    <hqStuPositionApply viewType="apply" slot="table"></hqStuPositionApply>
  </edu-layout>
</template>

<script>
import hqStuPositionApply from './base/hqStuPositionApply';
export default {
  components: {
    hqStuPositionApply
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {}
};
</script>
<style lang="less" scoped></style>
